import Collapse from "@mui/material/Collapse";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useLocalStorageState } from "./useLocalStorageState";

/**
 * Encabezado de sección colapsable (Favoritos / Recientes / Módulos), con
 * contador de elementos. El estado abierto/cerrado se recuerda por sección
 * (localStorage) para que la preferencia del usuario persista entre sesiones.
 */
export function MenuSection({ id, title, count, compact, children, defaultOpen = true }) {
  const [open, setOpen] = useLocalStorageState(`sidebar_section_${id}`, defaultOpen);

  if (compact) {
    // En modo compacto (solo íconos) no hay espacio para encabezados de
    // sección: se muestran los ítems directamente, sin agrupar visualmente.
    return <>{children}</>;
  }

  return (
    <div className="mb-1">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        className="flex w-full items-center justify-between px-3.5 pt-2 pb-1 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-morado rounded-md"
      >
        <span className="text-[10px] font-bold uppercase tracking-[0.09em] text-slate-500 dark:text-slate-400">
          {title}
        </span>
        <span className="flex items-center gap-1">
          {typeof count === "number" && (
            <span className="rounded-full bg-slate-200/80 px-1.5 py-0.5 text-[9.5px] font-semibold text-slate-600 dark:bg-white/10 dark:text-slate-300">
              {count}
            </span>
          )}
          <ExpandMoreRoundedIcon
            className={`text-[16px] text-slate-400 transition-transform duration-200 ${open ? "rotate-0" : "-rotate-90"}`}
          />
        </span>
      </button>

      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </div>
  );
}
